import React from 'react'

import classNames from 'classnames'

import { hasUnsavedChanges, isScore } from '@models/util/score.util'
import { useSession } from '@stores/globalData/globalData.store'

import type Product from '@models/Product'
import type Score from '@models/Score'

interface Props {
  score: Score | Product
  className?: string
  titleClassName?: string
}

const ScoreTitle: React.FC<Props> = ({ score, className }: Props) => {
  const session = useSession()
  return (
    <>
      <span className={classNames('ellipsify', className)}>{score.title}</span>

      {/* Only show alias and unsaved changes for 'score' and not 'product' */}
      {isScore(score) && (
        <>
          {score.alias && (
            <span className="ml-2.5 text-gray-text dark:text-gray-text-dm text-xs font-normal">
              {score.alias}
            </span>
          )}
          {hasUnsavedChanges(score, session.current_user) && (
            <span className="text-primary font-semibold">*</span>
          )}
        </>
      )}
    </>
  )
}

export default ScoreTitle
